import {
  PAYMENT_OTHER_ALL,
  PAYMENT_OTHER_GET,
  PAYMENT_OTHER_DELETE,
  PAYMENT_OTHER_PUT,
  PAYMENT_OTHER_POST,
  PAYMENT_OTHER_LOADING,
  PAYMENT_OTHER_ERROR,
} from '../types';

import api from '../../../utils/functions/api';

export const paymentOtherCreate = (payload) => async (dispatch) => {
  try {
    dispatch({ type: PAYMENT_OTHER_LOADING });
    const { data } = await api.post(
      `${process.env.REACT_APP_API_URL}/payment-other`,
      {
        ...payload,
      },
    );
    dispatch({ type: PAYMENT_OTHER_POST, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: PAYMENT_OTHER_ERROR });
    throw new Error(error);
  }
};

export const paymentOtherAll = (params) => async (dispatch) => {
  try {
    const { name = '', size = null, page = 1, date = '' } = params;
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/payment-other?name=${name}&size=${size}&page=${page}&date=${date}`,
    );
    if (status === 200) {
      dispatch({ type: PAYMENT_OTHER_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: PAYMENT_OTHER_ERROR });
    throw new Error(error);
  }
};

export const paymentOtherGet = (id) => async (dispatch) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/payment-other/${id}`,
    );
    if (status === 200) {
      dispatch({ type: PAYMENT_OTHER_GET, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: PAYMENT_OTHER_ERROR });
    throw new Error(error);
  }
};

export const paymentOtherPut = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: PAYMENT_OTHER_LOADING });
    const { data } = await api.put(
      `${process.env.REACT_APP_API_URL}/payment-other/${id}`,
      payload,
    );
    dispatch({ type: PAYMENT_OTHER_PUT, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: PAYMENT_OTHER_ERROR });
    throw new Error(error);
  }
};
export const paymentOtherDelete = (id) => async (dispatch) => {
  try {
    dispatch({ type: PAYMENT_OTHER_LOADING });
    const { data } = await api.delete(
      `${process.env.REACT_APP_API_URL}/payment-other/${id}`,
    );
    dispatch({ type: PAYMENT_OTHER_DELETE, payload: data });
  } catch (error) {
    const { status } = error.request;
    console.error(error);

    if (status === 403) {
      const message = 'ไม่สามารถลบข้อมูลเนื่องจากยังคงมีข้อมูลอยู่ในหมวดหมู่';
      dispatch({ type: PAYMENT_OTHER_ERROR, payload: { message } });
      throw new Error(message);
    } else {
      const message = 'เกิดข้อผิดพลาด';
      dispatch({ type: PAYMENT_OTHER_ERROR, payload: { message } });
      throw new Error(message);
    }
  }
};
